"use client";

import React from "react";

const BakerySchemaSnippet = () => {
  const bakeryData = {
    "@context": "http://schema.org",
    "@type": "Bakery",
    name: "Posh & Cake",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Bristol",
      postalCode: "BS13 8NY",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      bestRating: "5",
      ratingCount: "39",
      reviewCount: "39",
    },
    telephone: "0794 777 8028",
    url: "https://www.poshandcake.co.uk",
    logo: "https://poshandcake.cdn.prismic.io/poshandcake/Z6ALx5bqstJ9-Iym_logo-posh-and-cake-main.svg",
    image:
      "https://images.prismic.io/poshandcake/Z5_Y-5bqstJ9-IoY_posh-and-cake-at-royal-crescent-bath-uk.webp",
    priceRange: "££-£££",
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(bakeryData)}</script>
    </>
  );
};

export default BakerySchemaSnippet;
